/**
 * Insert `nodes` into `parent` before `beforeNode` using a single
 * DocumentFragment, reducing browser layout to one reflow.
 *
 * @param parent      Target parent element.
 * @param nodes       Nodes to insert. The array is read-only — nodes are moved
 *                    into a DocumentFragment, which then becomes a child of
 *                    `parent`. The caller's array is left intact.
 * @param beforeNode  Insert before this node. Pass `null` to append at the end.
 */
export function batchInsertBefore(
    parent: Node,
    nodes: Node[],
    beforeNode: Node | null,
): void {
    const len = nodes.length
    if (len === 0) return

    if (len === 1) {
        // Avoid DocumentFragment overhead for the common single-node case.
        parent.insertBefore(nodes[0], beforeNode)
        return
    }

    const frag = document.createDocumentFragment()
    for (let i = 0; i < len; i++) {
        frag.appendChild(nodes[i])
    }
    parent.insertBefore(frag, beforeNode)
}
